import { Component, contentChild, input, output, TemplateRef } from '@angular/core';
import { BrnCheckbox } from '@spartan-ng/brain/checkbox';
import { ThemedIconComponent } from '../themed-icon/themed-icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'ocp-checkbox',
  host: { class: 'ocp-spartan-scope' },
  imports: [BrnCheckbox, ThemedIconComponent, TranslatePipe, NgTemplateOutlet],
  template: `
    <label class="ocp-checkbox__wrapper">
      <brn-checkbox
        [checked]="checked()"
        [indeterminate]="!!indeterminate()"
        [disabled]="disabled()"
        [aria-label]="label() ? (label() | translate) : null"
        (checkedChange)="changeEvent.emit()"
      >
        @if (checked() || indeterminate()) {
          @if (checkboxIconTemplate()) {
            <ng-container *ngTemplateOutlet="checkboxIconTemplate()" />
          } @else {
            @if (indeterminate()) {
              <span style="color: white;">-</span>
            } @else {
              <ocp-themed-icon [size]="20" [name]="icon()" mode="dark" />
            }
          }
        }
      </brn-checkbox>
      @if (label() && showLabel()) {
        <span class="ocp-checkbox__label">{{ label() | translate }}</span>
      }
    </label>
  `,
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent {
  checked = input(false);
  indeterminate = input<boolean | undefined>(undefined);
  icon = input<string>('checkmark.svg');
  label = input<string>('');
  showLabel = input(false);
  disabled = input(false);
  changeEvent = output<void>();
  checkboxIconTemplate = contentChild<TemplateRef<unknown>>('checkboxicon');
}
